/*
 * NOTICE:  All information contained herein is, and remains the property of Power Settlements Consulting and Software, LLC.
 * The intellectual and technical concepts contained herein are proprietary to Power Settlements Consulting and Software, LLC
 * and are protected by trade secret or copyright law. Dissemination or reproduction of this material, in whole or in part,
 * is strictly forbidden without the prior written permission of Power Settlements Consulting and Software, LLC.
 * Copyright (c) Power Settlements Consulting and Software, LLC. All rights reserved.
*/

import moment from 'moment';
import { getMomentDateString, getMomentDateStringFromRangeArray } from '@/utils/dateUtil';
import { CISO_SAMC_API } from '@/api';

const state = {
  tableData: [],
};

const actions = {
  async fetchLoadedStatements({ commit }, args) {
    const { startDate, endDate } = getMomentDateStringFromRangeArray(args.tradeDateRangeSelected);
    const params = {
      scs: args.coordinatorListSelected,
      settlementType: args.fileTypesSelected,
      status: args.statusSelected,
      startDate,
      endDate,
    };
    try {
      const { data: { data } } = await CISO_SAMC_API.get('/loaded-statements', { params });
      data.forEach((x) => {
        x.tradeDate = getMomentDateString(x.tradeDate);
        x.processStarted = moment(x.processStarted).format('YYYY-MM-DD HH:mm:ss');
        x.processEnded = moment(x.processEnded).format('YYYY-MM-DD HH:mm:ss');
      });
      commit('setTableData', data);
    } catch (err) {
      this.$notify('Failed to Load Loaded Statement', 'error');
    }
  },
};

const mutations = {
  setTableData(state, value) {
    state.tableData = value;
  },
  reset(state) {
    state.tableData = [];
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};